import axios from '../axios'
import qs from "qs";

function service(endpoint) {

    function copy(id, data = {}) {
        return axios.post(`${endpoint}/${id}/copy`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function templates(data = {}) {
        return axios.get(`${endpoint}/templates`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        copy,
        templates
    }
}

export default service
